import Helmet from 'react-helmet';

import { useSSRContext } from 'ms-helpers/SSR/SSRContext';

type Props = {
  subtitles: Array<string>;
  images: Array<string>;
};

export default function OpenGraphTag(props: Props) {
  const [setSSRData] = useSSRContext();
  const metaOpenGraph = {
    metaOgTitle: props.subtitles.join(' | '),
    metaOgType: 'website',
    metaOgSiteName: 'Mathspace',
    metaOgImages: props.images,
    metaOgURL: window.location.href,
  };

  setSSRData(context => ({
    ...context,
    meta: {
      ...context.meta,
      metaOpenGraph,
    },
  }));

  return (
    <Helmet defer={false}>
      <meta name="og:title" content={props.subtitles.join(' | ')} />
      <meta name="og:type" content="website" />
      <meta name="og:site_name" content="Mathspace" />
      {props.images.map((image, index) => (
        <meta name="og:image" content={image} key={index} />
      ))}
      <meta name="og:url" content={window.location.href} />
    </Helmet>
  );
}
